export const modalMotion = {
  initial: { top: 250, left: '50%', opacity: 0, translateX: '-50%' },
  animate: { top: 160, left: '50%', opacity: 1, translateX: '-50%' },
  exit: {},
};
